import { z } from 'zod';
import { responseScheme } from '@/models/response';
import { avatarUrlSchema, nameSchema, stringifiedDateSchema } from '@/utils/schemas';

export const groupMemberScheme = z.object({
  ID: z.number(),
  GroupID: z.number(),
  GroupName: nameSchema,
  GroupImg: avatarUrlSchema,
  UserID: z.number(),
  UserNickName: nameSchema,
  RemarkName: nameSchema.default(''),
  DisplayName: nameSchema.default(''),
  Role: z.number(), // "10" admin; "9" manager(guan)
  GroupMemberName: nameSchema,
  UserHeadImg: avatarUrlSchema,
  Gender: z.number(),
  JoinTime: stringifiedDateSchema,
  ReadStatus: z.number(),
  Status: z.number(),
  OnLine: z.number(),
});

export const groupScheme = z.object({
  ID: z.number(),
  CreatorID: z.number(),
  CreatorName: nameSchema,
  CreatorHeadImg: avatarUrlSchema,
  GroupName: nameSchema,
  Info: z.string().nullable(),
  GroupImg: avatarUrlSchema,
  GroupType: z.literal(0).or(z.literal(1)).optional().default(0),
  UserCount: z.number(),
  MaxUserCount: z.number(),
  JoinType: z.number(),
  ReadDelete: z.number(),
  AutoDeleteTime: z.number(),
  LastMsgTimeStamp: z.number(),
  LastMsg: z.string(),
  AddFriend: z.number().default(0).pipe(z.coerce.boolean()),
  AllBan: z.number().default(0).pipe(z.coerce.boolean()),
  GroupCode: z.number(),
  Order: z.number().optional().default(0),
});

export const groupInfoScheme = responseScheme.merge(
  z.object({
    GroupJoinApplyCount: z.number().nullish(),
    GroupData: groupScheme.nullish(),
    Members: z.array(groupMemberScheme).nullish(),
    Self: groupMemberScheme
      .extend({
        GroupName: nameSchema,
        GroupImg: avatarUrlSchema,
        UserHeadImg: avatarUrlSchema,
      })
      .nullish(),
  }),
);

export enum GroupJoinMethod {
  ByQrCode = 1,
  ByInvitation = 2,
  ByLiveFansGroup = 3,
  ByOneStation = 4,
}

export const groupJoinMethodSchema = z.nativeEnum(GroupJoinMethod);

export const groupJoinApplicationScheme = z.object({
  ID: z.number(),
  UserID: z.number(),
  UserNickName: nameSchema,
  UserHeadImg: avatarUrlSchema,
  Source: z.string().nullish(),
  JoinMethod: groupJoinMethodSchema,
  Status: z.union([z.literal(0), z.literal(1), z.literal(2)]).default(0),
  CreateTime: stringifiedDateSchema,
});

export type GroupMember = z.infer<typeof groupMemberScheme>;

export type GroupInfo = z.infer<typeof groupInfoScheme>;

export type Group = z.infer<typeof groupScheme>;

export type GroupJoinApplication = z.infer<typeof groupJoinApplicationScheme>;
